<template>
  <div class="modal fade" :id="idModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ title }} </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">

                        <div class="form-row">
                            <div class="form-group col-12 col-md-4 offset-md-4">
                                <label for="brand_engine" class="badge badge-primary">Descripcion</label>
                                <input type="text" class="form-control" v-model="newParameter" name="flag" placeholder="Nombre" autocomplete="off">
                            </div>
                        </div>

                        <br>
                        <button class="btn btn-success col-12 col-md-4 offset-md-4" :disabled="readonly_btn" @click="mRegisterNewParameter"><font-awesome-icon icon="save" size="lg" /> Registrar</button>
                                                                       
                    </div>               
                    
                    <div class="modal-footer">
                        
                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal"><font-awesome-icon icon="times-circle" size="lg" /></button>
                        
                    </div>
                </div>
            </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';


export default {
    name:'modal-reg-global',
    props:{
        idModal:String,
        title:{
            type:String,
            default:'REGISTRO DE DATOS EN PARAMETRO GLOBAL'
        },
        parServer:String
    },
    data(){
        return{
            newParameter:null,
            readonly_btn:false
        }
    },
    methods:{
        mRegisterNewParameter(){
            
            if(this.newParameter !== null && this.newParameter.length > 2 ){
                let message = {
                    title: 'Registro de Nuevo parametro',
                    body: '¿Desea Registrar el nuevo Dato?'
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            // this.process_ordop.load=JSON.stringify(this.loads_declare);
                            this.readonly_btn=true;
                            console.log(this.newParameter);
                            let dts={
                                detail:this.newParameter
                            }
                            let s_new_param=await axios.post(`registerNewGlobal/${this.parServer}?api_token=${Vue.auth.getToken()}`, qs.stringify(dts));
                            setTimeout(()=>{                                
                                if(s_new_param.data.status){
                                    toastr.success(s_new_param.data.respuesta);                                    
                                    this.newParameter=null;                                    
                                }else{
                                    toastr.error(s_new_param.data.respuesta, 'Error');                                    
                                }
                                this.readonly_btn=false;
            
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso', 'Error P-01')
                                this.readonly_btn=false;
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo el nuevo parametro')
                        // console.log(this.s_pro_ordop);
                        toastr.warning(s_new_param.data.respuesta, 'Error');                                    
                    }
                })
            }else{
                toastr.warning('Debe indicar el detalle del registro', 'Advertencia');
            }
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/modal/modalRegGlobal.vue